/**
 * Hook to listen for global level up events via WebSocket
 * Automatically triggers the celebration when a global level up occurs
 */

import { useSimpleWebSocketEvent } from './useWebSocketEvent'
import { useCelebration } from '../contexts/CelebrationContext'
import { useConfetti } from '../contexts/ConfettiContext'
import audioManager from '../services/audioManager'

export function useGlobalLevelUp(isAuthenticated = false) {
  const { celebrateLevelUp } = useCelebration()
  const { trigger: triggerConfetti } = useConfetti()

  useSimpleWebSocketEvent(
    'player.global_level_up',
    (event) => {
      console.log('🎉 Global level up event received:', event)

      if (!event.new_level) {
        console.warn('Global level up event missing new_level:', event)
        return
      }

      // Trigger celebration
      celebrateLevelUp(event.new_level)

      // Trigger confetti
      triggerConfetti('legendary')

      // Play sound
      audioManager.play('levelup')
    },
    isAuthenticated,
    [celebrateLevelUp, triggerConfetti]
  )
}

export default useGlobalLevelUp
